module.exports = __webpack_public_path__ + "img/terminal-icon.4112f6b4.svg";